module.exports = __webpack_public_path__ + "static/prime-academy-logo.da646c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/prime-academy-logo.png
// module id = 481
// module chunks = 35783957827783